module.exports = __webpack_public_path__ + "img/4.8ae9e1c5.png";